import HandleLang from "./handleLang";
import {includes} from "lodash";
import Highcharts from "highcharts"

const handleChartableData = (data) => {

  const newSeries = []
  let chartableItems = []
  Object.values(data.rows).forEach((row, index) => {
    // console.log(index)

    if (row.chartable) {
      chartableItems.push(index)
    }

    let newRow = []
    Object.entries(row.data).forEach((row, index) => {
      if (includes(data.chartable_columns, row[0])) {
        newRow.push(parseFloat(row[1]))
      }
    })

    newSeries.push( {
      name: row.row_title,
      data: newRow,
      visible: index === chartableItems[0],
      showInLegend: index === chartableItems[0],
      yAxis: row.xAxis === 2 ? 1 : 0,
      type: index === chartableItems[0] ? 'column' : 'line',
      color: index === chartableItems[0] && 'rgba(255,77,46,0.6)',
    })
  })

  Highcharts.setOptions({
    lang: {
      thousandsSep: HandleLang('en') ? ',' : ' ',
      decimalPoint: HandleLang('en') ? '.' : ','
    }
  });

  return {
    chart: {
      backgroundColor: 'transparent',
      style: {
        fontFamily: ''
      }
    },
    tooltip: {
      shared: true,
    },
    navigation: {
      menuItemStyle: {
        fontWeight: 'normal',
        background: 'none'
      },
      menuItemHoverStyle: {
        background: 'none',
        color: 'rgba(255,77,46,0.6)'
      }
    },
    exporting: {
      enabled: true,
      buttons: {
        contextButton: {
          symbolSize: 18,
          symbolStroke: 'rgba(255,77,46,0.6)',
          theme: {
            fill: 'transparent',
            states: {
              hover: {
                fill: 'transparent'
              },
              select: {
                fill: 'transparent'
                // stroke: '#039',
                // fill: '#a4edba'
              }
            }
          },
          menuItems: [
            {
              text: HandleLang('en') ? 'Download data' : 'Ladda ner data',
              onclick: function () {
                const fileurl = data.file_download
                const filename = data.file_title

                const xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.onload = function() {
                  const a = document.createElement('a');
                  a.href = window.URL.createObjectURL(xhr.response); // xhr.response is a blob
                  a.download = filename; // Set the file name.
                  a.style.display = 'none';
                  document.body.appendChild(a);
                  a.click();
                  // delete a;
                };
                xhr.open('GET', fileurl);
                xhr.send();
              }
            },
            {
              text: HandleLang('en') ? 'Download PDF' : 'Ladda ner PDF',
              onclick: function () {
                this.exportChart({
                  type: 'application/pdf'
                });
              }
            },
            {
              text: HandleLang('en') ? 'Download JPEG' : 'Ladda ner JPEG',
              onclick: function () {
                this.exportChart({
                  type: 'image/jpeg'
                });
              }
            },
            {
              text: HandleLang('en') ? 'Download PNG' : 'Ladda ner PNG',
              onclick: function () {
                this.exportChart();
              }
            },
            // {
            //   separator: true
            // },
            {
              text: HandleLang('en') ? 'Print' : 'Skriva ut',
              onclick: function () {
                this.print();
              }
            }
          ]
        }
      }
    },
    title: {
      text: data.sheet_title,
      style: {
        fontSize: '20px'
      }
    },
    xAxis: {
      categories: Object.values(data.categories),
      reversed: !!data.flip_chart_data,
      labels: {
        style: {
          fontSize: '14px'
        }
      }
    },
    yAxis: [{ // Primary yAxis
      labels: {
        //format: '{value}°C',
        style: {
          fontSize: '14px'
        }
      },
      gridLineColor: '#d6d6d5',
      tickLength: 0,
      title: {
        text: data.sheet_y_title,
        style: {
          color: '#777777',
          fontSize: '16px'
        }
      }
    },
      { // Secondary yAxis
        title: {
          text: '',
          style: {
            color: '#777777',
          }
        },
        labels: {
          format: '{value}%',
          distance: 0,
          style: {
            fontSize: '14px'
          }
        },
        opposite: true
      }],
    series: newSeries,
    credits: {
      enabled: false
    },
  }
}

export default handleChartableData;
